import * as React from 'react'
import Nav from 'components/Nav/Nav'

function Layout({children}) {
   return ( 
      <>
         <Nav />
         {children}
      </>
    );
}

export default Layout;